// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Eh8z1","right":"Footer_right__1DguE","buttons":"Footer_buttons__1AWT5"};